import { enUS, sv } from "date-fns/locale";

import { Locale } from "@/constants";

const useActiveLocale = (language: Locale) => {
  return language === "sv" ? sv : enUS;
};

export default useActiveLocale;
